module.exports = __webpack_public_path__ + "static/img/password.3d0024cd.png";